import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import {
  FormRadio,
  FormMask,
  trEnv,
  If,
  istEnumAuswahl,
  onEnter,
  appActions,
  actions,
  EnumVorgangsart,
  Neuordnung,
  useUpdateAndValidateOnChange,
  SummingUpButtonLink,
} from 'ion-lib';
import { EnumNeuordnung, EnumProduktauswahl } from './enum';

const NeuordnungModal = ({
  container = null,
  getUKZ = () => '0102-***.***.***',
}) => {
  const auswahlNeuordnung = useSelector((state) => state.daten.auswahlNeuordnung);
  const produktauswahl = useSelector((state) => state.daten.produktauswahl);
  const vsnrHausratAltFuerNeuordnung = useSelector((state) => state.daten.vsnrHausratAltFuerNeuordnung);
  const vsnrHausratGlasAltFuerNeuordnung = useSelector((state) => state.daten.vsnrHausratGlasAltFuerNeuordnung);
  const hauptfaelligkeitVorvertrag = useSelector((state) => state.daten.hauptfaelligkeitVorvertrag);
  const vorgangsart = useSelector((state) => state.daten.vorgangsart);
  const show = useSelector((state) => state.appDaten.showNeuordnungModal);

  const dispatch = useDispatch();

  const validateOnChange = useUpdateAndValidateOnChange();

  const onButtonClick = () => {
    dispatch(appActions.serverValidationRequest('validiere', [
      'auswahlNeuordnung',
      'vsnrHausratAltFuerNeuordnung',
      'vsnrHausratGlasAltFuerNeuordnung',
      'hauptfaelligkeitVorvertrag',
    ], () => {
      handleClose();
    }));
  };

  const handleClose = () => {
    dispatch(actions.updateByName('appDaten.showNeuordnungModal', false));
  };

  const handleShow = () => {
    dispatch(actions.updateByName('appDaten.showNeuordnungModal', true));
  };

  const disabled = istEnumAuswahl(vorgangsart, EnumVorgangsart.NEUORDNUNG);

  if (!trEnv.stationaer) {
    return null;
  }

  return (
    <>
      <SummingUpButtonLink
        onClick={handleShow}
        title="Neuordnung"
        icon={<Neuordnung style={{ height: '2rem', width: '2rem', marginRight: '5px' }} />}
        disabled={disabled}
        className="text-primary"
      />

      <Modal
        show={show}
        container={container.current}
        centered={false}
        onHide={handleClose}
        size="lg"
        backdrop="static"
        backdropCloseAnimation
      >
        <Modal.Header closeButton className="modal-has-title">
          <Modal.Title>{istEnumAuswahl(produktauswahl, EnumProduktauswahl.HAUSRAT) ? 'Welche bestehenden Verträge sollen neu geordnet werden?' : 'Bestehenden Vertrag neuordnen.'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <If predicate={istEnumAuswahl(produktauswahl, EnumProduktauswahl.HAUSRAT)}>
            <FormRadio
              {...auswahlNeuordnung}
              name="daten.auswahlNeuordnung.value"
              onChange={validateOnChange}
            />
          </If>

          <If predicate={vsnrHausratAltFuerNeuordnung.relevant}>
            <hr className="mb-3 mx-n3" />
            <FormMask
              {...vsnrHausratAltFuerNeuordnung}
              title="Bitte geben Sie die Vertragsnummer des neuzuordnenden Hausrat-Vertrages ein:"
              name="daten.vsnrHausratAltFuerNeuordnung.value"
              onChange={(e) => dispatch(actions.updateByEvent(e))}
              onKeyDown={(e) => {
                onEnter(e, () => onButtonClick());
              }}
              inputmask={{
                mask: getUKZ(),
              }}
              className="mb-3"
            />
          </If>

          <If predicate={vsnrHausratGlasAltFuerNeuordnung.relevant || istEnumAuswahl(produktauswahl, EnumProduktauswahl.GLAS)}>
            <FormMask
              {...vsnrHausratGlasAltFuerNeuordnung}
              title={istEnumAuswahl(produktauswahl, EnumProduktauswahl.GLAS)
                ? 'Bitte geben Sie die Vertragsnummer des neuzuordnenden Vertrages ein:'
                : 'Bitte geben Sie die Vertragsnummer des neuzuordnenden Haushalt-Glas-Vertrages ein:'}
              name="daten.vsnrHausratGlasAltFuerNeuordnung.value"
              onChange={(e) => dispatch(actions.updateByEvent(e))}
              onKeyDown={(e) => {
                onEnter(e, () => onButtonClick());
              }}
              inputmask={{
                mask: getUKZ(),
              }}
            />
          </If>

          <If predicate={hauptfaelligkeitVorvertrag?.relevant}>
            <FormRadio
              {...hauptfaelligkeitVorvertrag}
              title={istEnumAuswahl(auswahlNeuordnung, EnumNeuordnung.KOMBI)
                ? 'Soll die Hauptfälligkeit der Vorverträge beibehalten werden?'
                : 'Soll die Hauptfälligkeit des Vorvertrages beibehalten werden?'}
              name="daten.hauptfaelligkeitVorvertrag.value"
              onChange={validateOnChange}
              className="mb-5"
            />
          </If>

          <hr className="mb-0 mx-n3" />
          <div className="mt-3 d-flex justify-content-between">
            <Button
              variant="secondary"
              onClick={handleClose}
            >
              Zurück
            </Button>
            <Button
              variant="primary"
              onClick={onButtonClick}
            >
              Weiter
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NeuordnungModal;
